import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { enhance } from '../enhance';
import Button from '../../../Button';
import TextInput from '../../../TextInput';
import Checkbox from '../../../common/Checkbox';
import iconSearch from '../../../../assets/icons/png/ic-search.png';

import styles from './styles.styl';

function PharmacyForm({
  id,
  formData,
  handleChange,
  handleSubmit,
  activeMailOrder,
  handleCheckboxToggle,
  intl: { formatMessage },
  withMailOrder = true,
}) {
  return (
    <div
      className={cn(styles.searchPharmacy, {
        [styles.withoutMailOrder]: !withMailOrder,
      })}
    >
      <form onSubmit={handleSubmit}>
        <div className={styles.searchBlock}>
          <TextInput
            limit={9}
            type="text"
            shouldUpperCase
            src={iconSearch}
            value={formData}
            placeholder={formatMessage({
              id: 'appointments.form.searchByZipCode',
            })}
            className={styles.inputStyles}
            onChange={handleChange}
          />
          <Button
            raised
            disabled={!id}
            color="primary"
            className={styles.confirmBtn}
          >
            {formatMessage({ id: 'submit.fillProfile' })}
          </Button>
        </div>
      </form>
      {withMailOrder && (
        <Checkbox
          size={16}
          id="pharmacy"
          checked={activeMailOrder}
          onChange={handleCheckboxToggle}
          className={styles.checkboxStyles}
          label={formatMessage({ id: 'appointments.form.showWithMailOrder' })}
        />
      )}
    </div>
  );
}

PharmacyForm.propTypes = {
  id: PropTypes.number,
  intl: PropTypes.object,
  formData: PropTypes.string,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  withMailOrder: PropTypes.bool,
  activeMailOrder: PropTypes.bool,
  handleCheckboxToggle: PropTypes.func,
};

export default enhance(PharmacyForm);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPharmacy/PharmacyForm/index.jsx